import { render, staticRenderFns } from "./DoorControl.vue?vue&type=template&id=031ffb0c&scoped=true&"
import script from "./DoorControl.vue?vue&type=script&lang=js&"
export * from "./DoorControl.vue?vue&type=script&lang=js&"
import style0 from "./DoorControl.vue?vue&type=style&index=0&id=031ffb0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ffb0c",
  null
  
)

export default component.exports